import { EARTH_RADIUS } from "@common/utils/Constants";
import { getUnix } from "@common/utils/Time";
import { convertThetaPhiToLatLng, radToDeg } from "@common/utils/UnitConverter";
import Feature from "../common/Feature";
import SourceLayer from "../common/SourceLayer";
export default class FlightSourceLayer extends SourceLayer {
    flights;
    t0;
    constructor(id, imageId, flights) {
        const features = flights.map((flight) => {
            const { lat, lng } = convertThetaPhiToLatLng(flight.theta, flight.phi);
            return new Feature(flight.id, lat, lng, radToDeg(flight.psi));
        });
        super(id, imageId, features);
        this.flights = flights;
        this.t0 = getUnix();
    }
    update() {
        const features = this.flights.map(({ id, theta, phi, speed, psi }) => {
            const angularSpeed = speed / EARTH_RADIUS;
            const thetaTilde = angularSpeed * (getUnix() - this.t0);
            const cosThetaTilde = Math.cos(thetaTilde);
            const sinThetaTilde = Math.sin(thetaTilde);
            const cosTheta = Math.cos(theta);
            const sinTheta = Math.sin(theta);
            const cosPhi = Math.cos(phi);
            const sinPhi = Math.sin(phi);
            const cosPsi = Math.cos(psi);
            const sinPsi = Math.sin(psi);
            const x = cosThetaTilde * sinTheta * cosPhi - sinThetaTilde * cosPsi * cosTheta * cosPhi - sinThetaTilde * sinPsi * sinPhi;
            const y = cosThetaTilde * sinTheta * sinPhi - sinThetaTilde * cosPsi * cosTheta * sinPhi + sinThetaTilde * sinPsi * cosPhi;
            const z = cosThetaTilde * cosTheta + sinThetaTilde * cosPsi * sinTheta;
            const ρ = Math.sqrt(x * x + y * y + z * z);
            const θ = Math.acos(z / ρ);
            const φ = Math.atan2(y, x);
            const { lat, lng } = convertThetaPhiToLatLng(θ, φ);
            return new Feature(id, lat, lng, radToDeg(psi));
        });
        return features;
    }
}
